// extracted by mini-css-extract-plugin
export default {"tabBar":"CompanyTabBar_tabBar__gEi++","tab":"CompanyTabBar_tab__4AGso","active":"CompanyTabBar_active__SjCpv","disabled":"CompanyTabBar_disabled__QL7dT"};